import type { HeaderLevel } from 'types/capi/content';

const CLASSES: Record<string, string> = {
  h1: 'text-3xl font-bold',
  h2: 'text-xl font-bold',
  h3: 'text-xl font-bold',
  h4: 'text-lg font-semibold',
  h5: 'text-md font-semibold',
  h6: 'text-sm font-semibold'
};

type Props = {
  children: string;
  level: HeaderLevel;
};

const Header = ({ level, children }: Props) => {
  const Element = level;
  const className = CLASSES[level];

  return <Element className={className}>{children}</Element>;
};

export default Header;
